import React, { useCallback, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import InputGroup from "../../../forms/InputGroup";
import { api_v2 } from "../../NewIndex.api";
import { validateField } from "../../../pages/functions";
import { getApplicationRegex } from "../../plugins/utils";
import { REF_DATA } from "../../../constants";
import connect from "react-redux/es/connect/connect";
import "./style.css";

const DuplicateModal = ({
  isModalOpen,
  closeModal,
  showNotification,
  liveVersionId,
  updateLive,
  referenceData,
  parentTemplateName,
  openMessageModal,
  setMessage,
}) => {
  const duplicateModalFields = {
    templateName: {
      name: "Template Name",
      value: "",
      rules: { title: "Template Name", required: true },
    },
    templateDesc: {
      name: "Template Description",
      value: "",
      rules: { title: "Template Description", required: true },
    },
    createdFrom: {
      name: "Duplicate From",
      value: parentTemplateName,
      rules: { title: "Duplicate From", required: true },
    },
  };
  const [fields, setFields] = useState(duplicateModalFields);

  const validate = useCallback(
    (e, field) => {
      const inputValue = e.target.value.toLowerCase();
      const ref_Data = referenceData.find(function (category) {
        return category.type === REF_DATA;
      }).referenceData;
      const regex = getApplicationRegex(ref_Data);

      if (regex.Emoji_Regex !== null && regex.Emoji_Regex.test(inputValue)) {
        showNotification(
          "Error!",
          "Special characters are not allowed",
          "error"
        );
        return;
      } else if (
        regex.Script_Regex !== null &&
        regex.Script_Regex.test(inputValue)
      ) {
        showNotification(
          "Error!",
          "Submission fails. Input contains prohibited words. Please remove them and try again.",
          "error"
        );
        return;
      } else if (regex.Script_Regex === null || regex.Emoji_Regex === null) {
        showNotification(
          "Error!",
          "Validation configuration is missing. Please contact support.",
          "error"
        );
        return;
      }
      const validateFields = validateField(e, field, fields);
      setFields({ ...validateFields });
    },
    [fields]
  );
  const handleSave = () => {
    const payload = {
      liveVersionId,
      templateName: fields.templateName.value,
      templateDescription: fields.templateDesc.value,
    };
    if (validTemplateName(payload.templateName)) {
      api_v2.duplicateTemplate(payload, (res) => {
        if (res.status === 200 && res.ok) {
          showNotification(
            "Success",
            "Template copied successfully",
            "success"
          );
          closeModal();
          getUpdateLiveList();
        } else if (res.status === 409) {
          closeModal();
          openMessageModal();
          setMessage(
            `Template Name must be unique. Name - ${payload.templateName} already exists as live template.`
          );
        } else {
          showNotification("Error!", "Please try again later", "error");
        }
      });
    } else {
      closeModal();
      openMessageModal();
      setMessage(
        `Name - ${payload.templateName} does not follow Template Naming rules. Please try again with a new name.`
      );
    }
  };
  const getUpdateLiveList = () => {
    api_v2.fetchTemplateLive((res) => {
      updateLive(res);
    });
  };
  const validTemplateName = (templateName) => {
    const urlRegex = /^[A-Za-z0-9_-]+$/;
    return urlRegex.test(templateName);
  };
  return (
    <Modal
      className="editTemplate-adminConfirmation-popup-modal"
      isOpen={isModalOpen}
      backdrop
      keyboard={false}
      wrapClassName="modal-primary"
      size="lg"
    >
      <div className="modal-title-color editTemplateDetails-modal-title">
        <h5>
          <strong>Edit Existing Template Details</strong>
        </h5>
      </div>
      <ModalBody>
        <div className="editTemplate-adminConfirmationModal-modal-body-content">
          <div
            className="row"
            style={{
              marginBottom: "10px",
              textAlign: "start",
              padding: "0 25px",
            }}
          >
            <p>Please follow the rules while creating the teamplate name:</p>
            <ul>
              <li>
                This allows only letters, numbers, hyphens, and underscores.
              </li>
              <li>Does not allow spaces or special characters.</li>
              <li>Does not allow slashes ('/').</li>
              <li>Template Name must be unqiue.</li>
            </ul>
          </div>
          <div
            className="row"
            style={{
              marginBottom: "10px",
              textAlign: "start",
              padding: "0 25px",
            }}
          >
            <InputGroup
              searchable={false}
              clearable={false}
              field={fields.templateName}
              validate={(e, field) => validate(e, fields.templateName)}
            />
          </div>
          <div
            className="row"
            style={{
              marginBottom: "10px",
              textAlign: "start",
              padding: "0 25px",
            }}
          >
            <InputGroup
              searchable={false}
              clearable={false}
              field={fields.templateDesc}
              validate={(e, field) => validate(e, fields.templateDesc)}
            />
          </div>
          <div
            className="row"
            style={{
              marginBottom: "10px",
              textAlign: "start",
              padding: "0 25px",
            }}
          >
            <InputGroup
              searchable={false}
              clearable={false}
              field={fields.createdFrom}
              validate={(e, field) => validate(e, fields.templateDesc)}
              disabled={true}
            />
          </div>
          <div className="editTemplate-adminConfirmationModal-popup-button">
            <button
              type="button"
              onClick={handleSave}
              className="btn btn-primary editTemplate-adminConfirmationModal-button btn-rounded"
              disabled={
                fields.templateName.value.length === 0 ||
                fields.templateName.value.trim().length === 0 ||
                fields.templateDesc.value.length === 0 ||
                fields.templateDesc.value.trim().length === 0
              }
            >
              Save
            </button>
            <button
              type="button"
              onClick={closeModal}
              className="btn btn-primary editTemplate-adminConfirmationModal-button btn-rounded"
            >
              Cancel
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  referenceData: state.referenceData,
});

export default connect(mapStateToProps)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/Content Management/DuplicateModal.js